<template>
  <SubContent  h="600px" @back="$router.push('/home')">
    <template v-slot:nav_left>
      <div>
        <span class="navTitle" @click="jumpTo('/siteFacilities/list')">机构场地管理</span>
        <span class="navTitle active">辅助配套设施</span>
      </div>
    </template>
    <div class="form_wrap">
      <vue-scroll>

        <div style="margin-right: 50px;">
          <fieldset class="vita-form-fieldset">
            <legend>高清视频系统</legend>
            <div class="itemSheshi">
              <div class="itemSheshiIn">
                <div>场地是否安装高清视频系统，无线网络覆盖场地</div>
                <div class="adioc">
                  <el-radio-group v-model="auxiliaryInfo.videoSystem" disabled>
                    <el-radio :label=true border>是</el-radio>
                    <el-radio :label=false border>否</el-radio>
                  </el-radio-group>
                </div>
              </div>
              <div class="adioc">
                <el-button type="primary" style="margin-right: 10px"  @click="editBu('videoSystem')">编辑</el-button>
              </div>
            </div>
            <div class="col" style="display:block">
              <div v-for="(item, index) in videoSystemFileList">
                  <span style="margin-bottom:10px">证明材料{{index+1}}：
                  <a
                    :href="$yioksConfig.transferBaseOnly(item.fileUrl)"
                    target="_blank"
                    :title="item.fileName"
                    style="font-size: 16px;line-height: 1.2em;margin-bottom: 10px;color:#4cd964"
                  >{{ item.fileName }}</a></span>
              </div>
            </div>
          </fieldset>

          <fieldset class="vita-form-fieldset">
            <legend>电子表现跟踪系统</legend>
            <div class="itemSheshi">
              <div class="itemSheshiIn">
                <div>引入EPTS（电子表现跟踪系统）</div>
                <div class="adioc">
                  <el-radio-group v-model="auxiliaryInfo.expressionSystem" disabled>
                    <el-radio :label=true border>是</el-radio>
                    <el-radio :label=false border>否</el-radio>
                  </el-radio-group>
                </div>
              </div>
              <div class="adioc">
                <el-button type="primary" style="margin-right: 10px" @click="editBu('expressionSystem')">编辑</el-button>
              </div>
            </div>
            <div class="col" style="display:block">
              <div v-for="(item, index) in expressionSystemFileList">
                  <span style="margin-bottom:10px">证明材料{{index+1}}：
                  <a
                    :href="$yioksConfig.transferBaseOnly(item.fileUrl)"
                    target="_blank"
                    :title="item.fileName"
                    style="font-size: 16px;line-height: 1.2em;margin-bottom: 10px;color:#4cd964"
                  >{{ item.fileName }}</a></span>
              </div>
            </div>
          </fieldset>

          <fieldset class="vita-form-fieldset">
            <legend>更衣室、淋浴间、体能训练房</legend>
            <div class="itemSheshi">
              <div class="itemSheshiIn">
                <div>场地附近有运动员更衣室、淋浴间、体能训练房等功能房和设施</div>
                <div class="adioc">
                  <el-radio-group v-model="auxiliaryInfo.changingRoom" disabled>
                    <el-radio :label=true border>是</el-radio>
                    <el-radio :label=false border>否</el-radio>
                  </el-radio-group>
                </div>
              </div>
              <div class="adioc">
                <el-button type="primary" style="margin-right: 10px" @click="editBu('changingRoom')">编辑</el-button>
              </div>
            </div>
            <div class="col" style="display:block">
              <div v-for="(item, index) in changingRoomFileList">
                  <span style="margin-bottom:10px">证明材料{{index+1}}：
                  <a
                    :href="$yioksConfig.transferBaseOnly(item.fileUrl)"
                    target="_blank"
                    :title="item.fileName"
                    style="font-size: 16px;line-height: 1.2em;margin-bottom: 10px;color:#4cd964"
                  >{{ item.fileName }}</a></span>
              </div>
            </div>
          </fieldset>

          <fieldset class="vita-form-fieldset">
            <legend>医务室</legend>
            <div class="itemSheshi">
              <div class="itemSheshiIn">
                <div>设立医务室，配备AED设备，与就近的周边医院建立绿色通道</div>
                <div class="adioc">
                  <el-radio-group v-model="auxiliaryInfo.dispensary" disabled>
                    <el-radio :label=true border>是</el-radio>
                    <el-radio :label=false border>否</el-radio>
                  </el-radio-group>
                </div>
              </div>
              <div class="adioc">
                <el-button type="primary" style="margin-right: 10px" @click="editBu('dispensary')">编辑</el-button>
              </div>
            </div>
            <div class="col" style="display:block">
              <div v-for="(item, index) in dispensaryFileList">
                  <span style="margin-bottom:10px">证明材料{{index+1}}：
                  <a
                    :href="$yioksConfig.transferBaseOnly(item.fileUrl)"
                    target="_blank"
                    :title="item.fileName"
                    style="font-size: 16px;line-height: 1.2em;margin-bottom: 10px;color:#4cd964"
                  >{{ item.fileName }}</a></span>
              </div>
            </div>
          </fieldset>

          <fieldset class="vita-form-fieldset">
            <legend>行政用房</legend>
            <div class="itemSheshi">
              <div class="itemSheshiIn">
                <div>各场地周边应配备行政用房</div>
                <div class="adioc">
                  <el-radio-group v-model="auxiliaryInfo.occupancy" disabled>
                    <el-radio :label=true border>是</el-radio>
                    <el-radio :label=false border>否</el-radio>
                  </el-radio-group>
                </div>
              </div>
              <div class="adioc">
                <el-button type="primary" style="margin-right: 10px" @click="editBu('occupancy')">编辑</el-button>
              </div>
            </div>
            <div class="col" style="display:block">
              <div v-for="(item, index) in occupancyFileList">
                  <span style="margin-bottom:10px">证明材料{{index+1}}：
                  <a
                    :href="$yioksConfig.transferBaseOnly(item.fileUrl)"
                    target="_blank"
                    :title="item.fileName"
                    style="font-size: 16px;line-height: 1.2em;margin-bottom: 10px;color:#4cd964"
                  >{{ item.fileName }}</a></span>
              </div>
            </div>
          </fieldset>

          <fieldset class="vita-form-fieldset">
            <legend>多媒体教室</legend>
            <div class="itemSheshi">
              <div class="itemSheshiIn">
                <div>有容纳50人以上的现代化多媒体教室</div>
                <div class="adioc">
                  <el-radio-group v-model="auxiliaryInfo.classroom" disabled>
                    <el-radio :label=true border>是</el-radio>
                    <el-radio :label=false border>否</el-radio>
                  </el-radio-group>
                </div>
              </div>
              <div class="adioc">
                <el-button type="primary" style="margin-right: 10px" @click="editBu('classroom')">编辑</el-button>
              </div>
            </div>
            <div class="col" style="display:block">
              <div v-for="(item, index) in classroomFileList">
                  <span style="margin-bottom:10px">证明材料{{index+1}}：
                  <a
                    :href="$yioksConfig.transferBaseOnly(item.fileUrl)"
                    target="_blank"
                    :title="item.fileName"
                    style="font-size: 16px;line-height: 1.2em;margin-bottom: 10px;color:#4cd964"
                  >{{ item.fileName }}</a></span>
              </div>
            </div>
          </fieldset>
        </div>
      </vue-scroll>
    </div>
    <template v-if="addSquad">
      <AddSquadDialog
        :addSquad.sync="addSquad"
        :isEdit="isEdit"
        :Info="facilityInfo"
        :squadUuid="auxiliaryInfo.uuid"
        @hideAddsquadDialog="hideAddsquadDialog" ></AddSquadDialog>
    </template>
  </SubContent>
</template>

<script>

import regions from '@/utils/regions'
import rules from '@/utils/formRules/center'
import siteFacilities from '@/api/siteFacilities'

export default {
  components: {
    'SubContent': () => import('@/components/layout/contentWithbtn'),
    'AddSquadDialog': () => import('@/components/siteFacilities/auxiliaryFacility')
  },
  mixins: [rules],
  data () {
    return {
      img: '',
      regions,
      videoSystemFileList: [],
      expressionSystemFileList: [],
      changingRoomFileList: [],
      dispensaryFileList: [],
      occupancyFileList: [],
      classroomFileList: [],
      isEdit: false,
      showTip: false,
      addSquad: false,
      auxiliaryInfo:{
        videoSystem:'',
        expressionSystem:'',
        changingRoom:'',
        dispensary:'',
        occupancy:'',
        classroom:'',
        uuid:'',
      },
      facilityInfo:{
        facilityName: '',
        facilityType: '',
        isCheck: '',
        uploadFileList: [],
      }

    }
  },

  computed: {

  },

  created () {
    this.getCompanyInfo()
  },
  methods: {
    typeFilter(val) {
      let res = '';
      switch(val) {
        case 'videoSystem':
          res = '场地是否安装高清视频系统，无线网络覆盖场地';
          break;
        case 'expressionSystem':
          res = '引入EPTS（电子表现跟踪系统）';
          break;
        case 'changingRoom':
          res = '场地附近有运动员更衣室、淋浴间、体能训练房等功能房和设施';
          break;
        case 'dispensary':
          res = '设立医务室，配备AED设备，与就近的周边医院建立绿色通道';
          break;
        case 'occupancy':
          res = '各场地周边应配备行政用房';
          break;
        case 'classroom':
          res = '有容纳50人以上的现代化多媒体教室';
          break;
        default:
          res = '--';
          break;
      }
      return res;
    },
    typeFileFilter(val) {
      let res = [];
      switch(val) {
        case 'videoSystem': res = this.videoSystemFileList; break;
        case 'expressionSystem': res = this.expressionSystemFileList; break;
        case 'changingRoom': res = this.changingRoomFileList; break;
        case 'dispensary': res = this.dispensaryFileList; break;
        case 'occupancy': res = this.occupancyFileList; break;
        case 'classroom': res = this.classroomFileList; break;
      }
      return res;
    },
    editBu(val){
      this.facilityInfo.facilityName = this.typeFilter(val);
      this.facilityInfo.facilityType = val;
      this.facilityInfo.isCheck = this.auxiliaryInfo[val];
      this.facilityInfo.uploadFileList = this.typeFileFilter(val);
      this.addSquad=true;
      this.isEdit=true;
    },
    jumpTo(path) {
      this.$router.replace(path)
    },
    getCompanyInfo () {
      siteFacilities.getAssistInfoYouth().then(res => {
        this.loading = false
        this.auxiliaryInfo = res.facilityAssist;
        this.videoSystemFileList=[];
        this.expressionSystemFileList=[];
        this.changingRoomFileList=[];
        this.dispensaryFileList=[];
        this.occupancyFileList=[];
        this.classroomFileList=[];

        if (res.contractList && res.contractList.length) {
          res.contractList.map(item=>{
            switch(item.facilityType) {
              case 'videoSystem': this.videoSystemFileList.push(item); break;
              case 'expressionSystem': this.expressionSystemFileList.push(item); break;
              case 'changingRoom': this.changingRoomFileList.push(item); break;
              case 'dispensary': this.dispensaryFileList.push(item); break;
              case 'occupancy': this.occupancyFileList.push(item); break;
              case 'classroom': this.classroomFileList.push(item); break;
            }
          })

        }
      }).catch(err => {
        this.loading = false
        console.log(err)
      })
    },
    hideAddsquadDialog (flag) {
      this.isEdit = false
      this.addSquad = flag
      this.getCompanyInfo()
    },
  }
}
</script>

<style lang="stylus" >
  .itemSheshi{
    .el-radio{
      color: #ffffff;
      margin-right:0;
    }
    .el-radio__input.is-disabled.is-checked .el-radio__inner::after{
      background-color: #4cd964;
    }
    .el-radio.is-bordered.is-checked{
      border-color: #4cd964 !important
    }
  }
</style>
<style lang="stylus" scoped>
  @import '~@/assets/css/variable'
  .navTitle
    padding 10px 20px
    /*margin-right .2rem*/
    cursor pointer
    &:last-child
    &:last-child
      margin-right 0
    &.active
      background $green_color
      color #FFF
  .form_wrap
    padding 20px 0 20px 50px
    overflow hidden
    box-sizing border-box
    flex 1
    font-size 16px
    .vita-form-fieldset
      margin-bottom 18px
      &:last-child
        margin-bottom 0
      legend
        color: #f88594;
        padding: 0 10px;
    .itemSheshi
      display flex
      justify-content: space-between;
    .itemSheshiIn
      display flex
      align-items center
    .adioc
      margin-left 20px

  .btn_wrap
    width 100%
    display flex
    justify-content center
</style>


